import React, { useState } from 'react';
import '../../animation/anima.css';
import Alltoggle from '../work/Togglesections/Alltoggle.jsx';
import Mobiletoggle from '../work/Togglesections/Mobiletoggle.jsx';
import Webtoggle from '../work/Togglesections/Webtoggle.jsx';

const Section2 = () => {
    const [selectedButton, setSelectedButton] = useState('All');

    const handleButtonClick = (text) => {
        setSelectedButton(text);
    };

    return (
        <>
            <div className="flex items-center justify-center max-w-[1200px]">
                <div className="bg-prime flex justify-evenly items-center mt-10 rounded-lg h-28">
                {['All', 'Mobile', 'Web'].map((text, index) => (
                    <button
                        key={index}
                        className={`about-button mx-5 text-white text-xl font-bold font-prime font-xl p-5 px-24 ${selectedButton === text ? (text === 'All' ? 'initial-effect' : '') : ''}`}
                        onClick={() => handleButtonClick(text)}
                    >
                        {text}
                    </button>
                ))}
            </div>
            </div>
            {selectedButton === 'All' && <Alltoggle />}
            {selectedButton === 'Mobile' && <Mobiletoggle />}
            {selectedButton === 'Web' && <Webtoggle />}
        </>
    );
};

export default Section2;
